<template>
        <div class="w-full">
          <div class="w-full md:w-1/2 mx-auto">
            <div class="w-full mt-10">
              <h1 class="text-center font-bold tracking-wider text-2xl md:text-3xl font-viga text-secondary mb-5" >
                  Riwayat Pendaftaran
              </h1>
           </div>
            <div v-if="antrians" class="w-full">
              <HistoryCard
                v-for="antrian in antrians"
                :antrian = "antrian"
              />
            </div>
            <div v-else class="w-full mt-2">
                <div class="w-full h-20 flex items-center bg-red-600 p-2 rounded-lg text-white justify-center">
                        BELUM ADA DATA PENDAFTARAN
                  </div>
            </div>
        </div>
        </div>
</template>


<script>
import { Link } from '@inertiajs/inertia-vue3'
import LayoutNoHeader from '../Shared/LayoutNoHeader.vue'
import RandomShape from '../Shared/RandomShape.vue';
import HistoryCard from '../Shared/HistoryCard.vue';
export default{
    components: {
    Link,
    RandomShape,
    HistoryCard,
},
    props: {
      antrians: Array
    },
    layout: LayoutNoHeader
}
</script>